import { Link } from 'react-router-dom';
import { EmptyState } from '@/components/Misc';

export function NotFoundPage() {
  return (
    <div className="flex h-full items-center justify-center">
      <EmptyState title="Page not found" body="The link may be broken or the item was removed." action={<Link to="/" className="text-accent hover:underline">Go home</Link>} />
    </div>
  );
}
